import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./app/App";
import { installStaleChunkRecovery } from "./lib/staleChunkRecovery";
import "./ztd-design-system.css";

installStaleChunkRecovery();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
